// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"691":"component---src-pages-index-tsx","774":"framework"}[chunkId] || chunkId) + "-" + {"217":"312e2af729f1a9ec8b7e","622":"05d4980b7b8e4bfbc804","691":"e448b6b35917f785997e","774":"7af130e9531dfbb5f207"}[chunkId] + ".js";
};